export const MYDATA = "MYDATA";
export const RIGHTPANEL = "RIGHTPANEL";
export const BOTTOMPANEL = "BOTTOMPANEL";
export const BOTTOMLEGENDPANEL = "BOTTOMLEGENDPANEL";
export const LEFTPANEL = "LEFTPANEL";
export const CCTVHISTORIS = "CCTVHISTORIS";
export const CCTVMAP = "CCTVMAP";
export const CCTVTOKEN = "CCTVTOKEN";
export const CAMPAIGN = "CAMPAIGN";

export function pushCctvMap(values) {
  return {
    type: CCTVMAP,
    payload: values
  };
}

export function pushCctvToken(values) {
  return {
    type: CCTVTOKEN,
    payload: values
  };
}

export function pushCctvhistoris(values) {
  return {
    type: CCTVHISTORIS,
    payload: values
  };
}

export function pushMydata(values) {
  return {
    type: MYDATA,
    payload: values
  };
}

export function pushRightPanel(values) {
  return {
    type: RIGHTPANEL,
    payload: values
  };
}

export function pushBottomPanel(values) {
  return {
    type: BOTTOMPANEL,
    payload: values
  };
}

export function pushBottomLegendPanel(values) {
  return {
    type: BOTTOMLEGENDPANEL,
    payload: values
  };
}

export function pushLeftPanel(values) {
  return {
    type: LEFTPANEL,
    payload: values
  };
}

export function pushCampaign(values) {
  return {
    type: CAMPAIGN,
    // temporary turn off campaign popup
    payload: false
  };
}
